import { render, staticRenderFns } from "./SkeletonTable.vue?vue&type=template&id=5e9ad61e&scoped=true&"
import script from "./SkeletonTable.vue?vue&type=script&lang=js&"
export * from "./SkeletonTable.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonTable.vue?vue&type=style&index=0&id=5e9ad61e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9ad61e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e9ad61e')) {
      api.createRecord('5e9ad61e', component.options)
    } else {
      api.reload('5e9ad61e', component.options)
    }
    module.hot.accept("./SkeletonTable.vue?vue&type=template&id=5e9ad61e&scoped=true&", function () {
      api.rerender('5e9ad61e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Orders/components/SkeletonTable.vue"
export default component.exports